module.exports = __webpack_public_path__ + "img/gift4.413ac938.png";